import { getUserAgent, UA } from "../../../../utils/ua"
import { getParam } from "../../../../utils/url"
import { ActivityForUsers, Info, INFO } from "../../config"
import { getNowTimeStamp } from "../../helper"

export interface Partition {
  area?: string
  partition: string
  game_platform_id?: string
}

export interface UserZone {
  zone_id: string
  zone_name: string
  partition_info: Partition
}

export interface UserRole {
  supportRole?: boolean
  role_id: string
  role_name: string
}
export interface SelectedCoupon {
  cardId: string
  batchId: string
  saving: number
  codeId: string
  leastPrice: number
  threshold: number
}
export interface AppleGiftCardState {
  pf: string
  pfSource: string
  sandbox: string
  wx_appid: string
  userAgent: UA
  openid: string
  offerId: string
  openkey: string
  sessionId: string
  sessionType: string
  userInfo: any // TODO
  wechatRealnameToken: string
  productName: string
  productId: string
  productItem: Info["BUY_COLUMN"]
  configInfo: Info
  userDrmDiscountQualified: boolean
  availableCoupons: any // TODO
  selectedCoupon: SelectedCoupon | null
  agreeChecked: boolean
  isLoading: boolean
  buyNum: string
  maskId: string
  hideWarn: boolean
  toastMsg: string
  toastMsgTimer: number | null
  usingLocation: UsingLocation
  notSign: boolean
  giftTaskConfig: Info["giftTaskConfig"]
  activityOfferId?: string
  isLoggedIn: boolean
  nowTime: number
  selectedZone: UserZone | null
  selectedRole: UserRole | null
  recommModel: {
    android: string
    iOS: string
  }
  appleCardGroupId: string
  tx_trace_key?: string
  userTypeActivity?: ActivityForUsers
}

export const enum UsingLocation {
  HOME = "HOME",
  APPLE_GIFT_CARD = "APPLE_GIFT_CARD"
}

const state: AppleGiftCardState = {
  pf: getParam("pf") || "mds_wx_default",
  pfSource: "mds_wechat_qb",
  sandbox: getParam("sandbox"),
  wx_appid: getParam("wx_appid") || "wx951bdcac522929b6",
  userAgent: getUserAgent(),
  openid: "",
  offerId: "1450022280",
  openkey: "",
  sessionId: "",
  sessionType: "",
  userInfo: null,
  wechatRealnameToken: "",
  productName: INFO.productName,
  productId: INFO.productId,
  productItem: [],
  configInfo: INFO,
  userDrmDiscountQualified: true,
  availableCoupons: null,
  selectedCoupon: null,
  agreeChecked: !!localStorage.getItem("apple-gift-card__agreeChecked"),
  isLoading: false,
  buyNum: "",
  maskId: "",
  hideWarn: true,
  toastMsg: "",
  toastMsgTimer: null,
  usingLocation: UsingLocation.APPLE_GIFT_CARD,
  notSign: true,
  giftTaskConfig: INFO.giftTaskConfig,
  activityOfferId: getParam("activityOfferId"),
  isLoggedIn: false,
  nowTime: getNowTimeStamp(),
  selectedZone: null,
  selectedRole: null,
  recommModel: {
    android: "wzry_partition_all_android",
    iOS: "wzry_partition_all_ios"
  },
  appleCardGroupId: "464",
  tx_trace_key: getParam("tx_trace_key"),
  userTypeActivity: undefined
}

export default state
